/**
 * PURPOSE: Ensures deal history is refreshed when it is necessary to update the app state with new information.
 */

// libraries
import type { AnyFSA } from '@makemydeal/dr-browser-utils';

// actions
import * as dealHistoryActionCreators from '../actions/dealHistoryActionCreator';

// consts/enums
import { OFFER_SAVE_NOCHANGE_SUCCESS, OFFER_SAVE_SUCCESS } from '../actionTypes/offerActionTypes';
import { SOCKET_EVENT_RECEIVED } from '../actionTypes/socketActionTypes';

// selectors
import * as offerInfoSelectors from '../selectors/offerInfoSelectors';
import * as dealValidationSelectors from '../selectors/dealValidationSelectors';

// interfaces/types
import type { DashMiddleware, DashStore, DashNext } from '@makemydeal/dr-shared-store';
import { bootstrapActionTypes } from '@makemydeal/dr-shared-store';
import type { StateTree } from '@makemydeal/dr-dash-types';

export const willRefetchHistoryOnSocketEvent = (state: StateTree): boolean => {
    const updatedMilestones = offerInfoSelectors.getSocketEventUpdatedMilestones(state);
    return (
        offerInfoSelectors.getSocketEventIsPaymentUpdate(state) ||
        updatedMilestones.length === 0 ||
        updatedMilestones.includes('offer')
    );
};

export const middleware: DashMiddleware = (store: DashStore) => (next: DashNext) => (action: AnyFSA) => {
    next(action);
    const state = store.getState();

    const isDealValid = dealValidationSelectors.isDealValid(state);
    if (!isDealValid) {
        return;
    }

    switch (action.type) {
        case bootstrapActionTypes.BOOTSTRAP_SUCCESS:
        case OFFER_SAVE_NOCHANGE_SUCCESS:
        case OFFER_SAVE_SUCCESS: {
            // fetch snapshots
            // TODO: DASH - what should happen if this fails?
            if (action.meta?.isDraft) {
                break;
            }
            store.dispatch(dealHistoryActionCreators.fetchDealHistory(state));
            break;
        }
        case SOCKET_EVENT_RECEIVED: {
            if (willRefetchHistoryOnSocketEvent(state)) {
                store.dispatch(dealHistoryActionCreators.fetchDealHistory(state));
            }

            break;
        }
    }
};
